import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'antd';

import { EQUIPMENT_CATEGORY_ID, MATERIAL_CATEGORY_ID } from '../../../../helpers/costcodeHelpers';
import {
  getBasicCostColumns,
  getEquipmentCostColumns,
  getMaterialCostColumns,
} from '../../../ProjectProgress/ProgressColumns';

export default function CostTrackingCostUpdatesModal({
  visible,
  record,
  costUpdates,
  onClose,
}) {
  const columns = useMemo(() => {
    const { categoryId } = record ?? {};
    if (categoryId === MATERIAL_CATEGORY_ID) return getMaterialCostColumns();
    if (categoryId === EQUIPMENT_CATEGORY_ID) return getEquipmentCostColumns();
    return getBasicCostColumns();
  }, [record]);

  const title = `Cost Updates — ${record?.displayName || record?.name}`;

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width="60vw"
      destroyOnClose
      centered
      title={title}
      className="cost-tracking-cost-updates-modal"
      bodyStyle={{
        padding: '36px 42px',
        margin: 0,
      }}
    >
      <Table
        columns={columns}
        dataSource={costUpdates}
        pagination={false}
        rowKey={(row, index) => row.id ?? index}
        size="small"
        scroll={{ x: true }}
        className="cost-tracking-cost-updates-table"
      />
    </Modal>
  );
}

CostTrackingCostUpdatesModal.propTypes = {
  visible: PropTypes.bool,
  record: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    categoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  costUpdates: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func.isRequired,
};

CostTrackingCostUpdatesModal.defaultProps = {
  visible: false,
  record: null,
  costUpdates: [],
};
